export default __webpack_public_path__ + "static/media/jamuna-2.9c77bb87.PNG";